/**
 * Copyright 2022 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const getCustomerServiceRolePolicy = `query getCustomerServiceRolePolicy($customer_id: String!) {
  customerServiceRolePolicy(customer_id: $customer_id)
}
`;
